import { purifier } from "../util/dom";
var createTpInvitation = function createTpInvitation(data) {
  if (!data.hasOwnProperty('order')) return;
  if (typeof tp !== 'function') return;
  var trustpilotInvitation = {
    recipientEmail: "".concat(purifier(data.address.email) || ''),
    recipientName: "".concat(purifier(data.address.firstName) || '', " ").concat(purifier(data.address.lastName) || ''),
    referenceId: "".concat(purifier(data.order)),
    source: 'InvitationScript'
  };
  tp('createInvitation', trustpilotInvitation);
};
export default createTpInvitation;


// WEBPACK FOOTER //
// ./scripts/components/trustpilot.js